import _implicitStylesheets from "./compatibility.css";
import _implicitScopedStylesheets from "./compatibility.scoped.css?scoped=true";
import _wdsTitledGroup from "wds/titledGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-7"${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<div data-testid="additional-requirements-div" class="additional-requirements${0}"${2}><span type-style="body-3"${3}>${"t2"}</span><div type-style="body-3"${3}>${"t4"}</div></div>`;
const stc0 = {
  classMap: {
    "compatibility-wrapper": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "titled-group-wrapper": true
  },
  attrs: {
    "data-testid": "require-products-div"
  },
  key: 3
};
const stc2 = {
  classMap: {
    "titled-group-wrapper": true
  },
  attrs: {
    "data-testid": "recommended-products-div"
  },
  key: 5
};
const stc3 = {
  classMap: {
    "titled-group-wrapper": true
  },
  attrs: {
    "data-testid": "salesforce-editions-div"
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.labels.title))]), $cmp.compatibilityProps.requiredProducts.length ? api_element("div", stc1, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "tooltip": $cmp.requireContentsTooltip,
      "title": $cmp.labels.requiredProductsGroup,
      "badges": $cmp.compatibilityProps.requiredProducts
    },
    key: 4
  })]) : null, $cmp.compatibilityProps.compatibleWith.length ? api_element("div", stc2, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "tooltip": $cmp.compatibilityTooltip,
      "title": $cmp.labels.compatibleWith,
      "badges": $cmp.compatibilityProps.compatibleWith
    },
    key: 6
  })]) : null, $cmp.compatibilityProps.salesforceEditions.length ? api_element("div", stc3, [api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.labels.salesforceEditionsGroup,
      "badges": $cmp.compatibilityProps.salesforceEditions
    },
    key: 8
  })]) : null, $cmp.compatibilityProps.additionalRequirements ? api_static_fragment($fragment2, 10, [api_static_part(2, null, api_dynamic_text($cmp.labels.additionalRequirements)), api_static_part(4, null, api_dynamic_text($cmp.compatibilityProps.additionalRequirements))]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7rtrd86rpke";
tmpl.legacyStylesheetToken = "undefined-_compatibility";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
